import { createContext, useState } from "react";

export const FormationContext = createContext();

export const FormationProvider = ({ children }) => {
    const [selectedFormation, setSelectedFormation] = useState({
        title: "",
        image: "",
        thematic: "",
        resume: "",
        content: "",
    });

    const selectFormation = (formation) => {
        console.log(formation)
        setSelectedFormation(formation);
    }

    return (
        <FormationContext.Provider value={{ selectedFormation, selectFormation }}>
            {children}
        </FormationContext.Provider>
    );
}

export default FormationContext;
